import { useState, useRef } from "react";
import {
  Carousel as CarouselComponent,
  Row,
  Col,
  Image,
  Progress,
  Space,
} from "antd";
import { Layout } from "antd";
import { CommonButton } from "../CommonButton";
import carouselBg from "../../assets/images/home/slider.webp";
import gartnerBg from "../../assets/images/home/gartner-bg.webp";
import upLine from "../../assets/images/home/up-line.webp";
import downLine from "../../assets/images/home/down-line.webp";
import leftLine from "../../assets/images/home/left-line.webp";
import rightLine from "../../assets/images/home/right-line.webp";
import { CarouselRef } from "antd/es/carousel";
import { BsArrowRight } from "react-icons/bs";
import mobile_bg from "../../assets/images/home/carousel/mobile-bg.png";
import { useLocation, useNavigate } from "react-router-dom";

interface HomePageCarouselDataType {
  id: number;
  title: string;
  title_mob: string;
  subTitle: string;
  bgImage: string;
  redirectionUrl: string;
  link: string;
  buttonText: string;
}

type HomePageCarouselProps = {
  data: HomePageCarouselDataType[];
};

const Carousel = ({ data }: HomePageCarouselProps) => {
  const location = useLocation();
  const navigate = useNavigate();

  const { Content } = Layout;
  const [currentSlide, setCurrentSlide] = useState(0);
  const slider = useRef<CarouselRef | null>(null);

  const totalItems = data.length;
  const progressPercent = ((currentSlide + 1) / totalItems) * 100;

  const goToNextSlide = () => {
    if (slider && slider.current) {
      slider?.current?.next();
    }
  };

  const goToPrevSlide = () => {
    if (slider && slider.current) {
      slider?.current?.prev();
    }
  };

  return (
    <Layout className="carousel">
      <CarouselComponent
        effect={"fade"}
        dots={false}
        autoplay={true}
        draggable={true}
        autoplaySpeed={3000}
        afterChange={(current) => setCurrentSlide(current)}
        initialSlide={currentSlide}
        ref={(ref) => {
          slider.current = ref;
        }}
        style={{ minHeight: "90vh" }}
      >
        {data.map((item: HomePageCarouselDataType, index) => {
          return (
            <>
              <Row
                className="fullCarousel"
                style={{
                  backgroundImage: `url(${carouselBg})`,
                  backgroundColor: "#1D1A36",
                }}
              >
                {/* desktop view */}
                <Col
                  xs={0}
                  sm={0}
                  md={24}
                  lg={24}
                  xl={24}
                  xxl={24}
                  style={{ minHeight: "100% !important" }}
                >
                  <Row style={{ height: "100%" }}>
                    <Col
                      xs={0}
                      sm={0}
                      md={23}
                      lg={23}
                      xl={23}
                      xxl={23}
                      style={{
                        height: "100%",
                        backgroundImage: `url(${item?.bgImage})`,
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "contain",
                        backgroundOrigin: "content-box",
                        padding: "20px 20px 20px 20px",
                      }}
                    >
                      <Row style={{ height: "100%" }}>
                        <Col
                          xs={14}
                          sm={14}
                          md={14}
                          lg={14}
                          xl={14}
                          xxl={14}
                          className="leftCarousel"
                        >
                          <Row gutter={[16, 16]}>
                            <Col
                              span={24}
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <Image
                                src={item.title}
                                alt="title"
                                preview={false}
                                style={{ width: "40vw" }}
                              />
                            </Col>
                            <Col span={24}>
                              <h1 className="carouselSubTitle">
                                {item.subTitle}
                              </h1>
                            </Col>
                            <Col span={24}>&nbsp;</Col>
                            <Col span={24}>
                              <CommonButton
                                buttonText={item.buttonText}
                                link={"#"}
                                style={{ marginTop: "0" }}
                                onClick={() => {
                                  if (item?.link) {
                                    navigate(item.link);
                                  } else if (item?.redirectionUrl) {
                                    window.open(item?.redirectionUrl, "_blank");
                                  }
                                }}
                                icon={<BsArrowRight style={{ padding: 0 }} />}
                              />
                            </Col>
                          </Row>
                        </Col>
                        <Col
                          xs={10}
                          sm={10}
                          md={10}
                          lg={10}
                          xl={10}
                          xxl={10}
                        ></Col>
                      </Row>
                    </Col>

                    <Col xs={0} sm={0} md={1} lg={1} xl={1} xxl={1}>
                      <Row gutter={[8, 32]} className="carouselSideDiv">
                        <Col span={24}>
                          <Image
                            src={upLine}
                            alt="upLine"
                            preview={false}
                            onClick={() => goToNextSlide()}
                            className="carouselSideDivImg"
                          />
                        </Col>
                        <Col span={24}>
                          <div className="carouselID">0{index + 1}</div>
                        </Col>
                        <Col span={24}>
                          <Image
                            src={downLine}
                            alt="downLine"
                            preview={false}
                            onClick={goToPrevSlide}
                            className="carouselSideDivImg"
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
                {/* desktop view */}

                <Col
                  xs={24}
                  sm={24}
                  md={0}
                  lg={0}
                  xl={0}
                  xxl={0}
                  style={{ minHeight: "100% !important" }}
                >
                  <Row style={{ height: "100%" }}>
                    <Col span={24}>&nbsp;</Col>
                    <Col span={24} style={{ textAlign: "center" }}>
                      <Image
                        preview={false}
                        src={item?.title_mob}
                        style={{ height: "15rem" }}
                      />
                    </Col>
                    <Col
                      span={24}
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <Image
                        src={item.title}
                        alt="title"
                        preview={false}
                        style={{ width: "80vw" }}
                      />
                    </Col>
                    <Col span={24}>
                      <h1 className="carouselSubTitle">{item.subTitle}</h1>
                    </Col>
                    <Col span={24}>
                      <CommonButton
                        buttonText={item.buttonText}
                        link={"#"}
                        style={{ marginTop: "0", width: "60%" }}
                        onClick={() => {
                          if (item?.link) {
                            navigate(item.link);
                          } else if (item?.redirectionUrl) {
                            window.open(item?.redirectionUrl, "_blank");
                          }
                        }}
                        icon={<BsArrowRight style={{ padding: 0 }} />}
                      />
                    </Col>
                    <Col span={24}>
                      <Row className="carouselBottomDiv">
                        <Col span={11} style={{ textAlign: "center" }}>
                          <Image
                            src={leftLine}
                            alt="leftLine"
                            preview={false}
                            onClick={() => goToPrevSlide()}
                            className="carouselBottomImg"
                          />
                        </Col>

                        <Col
                          span={2}
                          style={{ textAlign: "center", color: "#FFF" }}
                        >
                          <div className="carouselID">0{index + 1}</div>
                        </Col>

                        <Col span={11} style={{ textAlign: "center" }}>
                          <Image
                            src={rightLine}
                            alt="rightLine"
                            preview={false}
                            onClick={goToNextSlide}
                            className="carouselBottomImg"
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </>
          );
        })}
      </CarouselComponent>
      <Row
        align={"middle"}
        justify={"center"}
        style={{ backgroundColor: "#1d1a36", height: "1.5vh" }}
      >
        <Col xs={22} sm={22} md={10} lg={10} xl={10} xxl={10}>
          <Progress
            percent={progressPercent}
            showInfo={false}
            style={{
              marginTop: "1.4vh",
            }}
          />
        </Col>
      </Row>
    </Layout>
  );
};

export default Carousel;
